<template>
  <b-col cols="12" md="6" lg="3" class="card-wrapper" v-if='affiliateAdvertisers.length > 0'>
    <div class="card">
      <img class="cover" :src="this.campaignCover" :alt="campaign.name">
      <div class="content">
        <h5 class="title">{{campaign.name}}</h5>
        <div class="description-item first">
          <img src="../assets/money.svg" alt="Recebimento">
          <div v-html="this.campaignDescription"/>
        </div>
        <div class="description-item">
          <img src="../assets/chart.svg" alt="Payout">
          <div>Tipo de Payout: <span>{{campaign.commission_types}}</span></div>
        </div>
        <div class="description-item last">
          <img src="../assets/monitor.svg" alt="Cookie">
          <div>Validade do cookie: <span>{{campaign.commission_window}}</span></div>
        </div>
        <div v-if="this.campaign.moderate === 0 || moderate === 'aproved'" v-on:click= "setCampaign(campaign)">
          <router-link :to="{ path: this.campaignUrl }">
            Divulgue já
          </router-link>
        </div>
        <div v-else>
          <button @click="requestModeration(campaign.id)" class="btn btn-moderation"
          :disabled='isDisabled'>
            {{ this.textButton }}
          </button>
        </div>
      </div>
    </div>
  </b-col>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import AdvertiserProgramApi from '@/services/advertiserProgram';
import store from '@/store';

export default {
  name: 'CampaignCard',
  props: ['campaign'],
  data() {
    return {
      moderate: '',
      textButton: '',
      isDisabled: false,
    };
  },
  computed: {
    ...mapGetters(['affiliateAdvertisers']),
    campaignCover() {
      return this.campaign.cover_url ? this.campaign.cover_url : this.campaign.url;
    },
    campaignUrl() {
      return `campanha/${this.campaign.code}`;
    },
    queryObject() {
      const qs = window.location.search;
      const queryObject = {};
      qs.substr(1).split('&').forEach((_param) => {
        const param = _param.split('=');
        const key = param.shift();
        const value = param.shift();
        queryObject[key] = value;
      });
      return queryObject;
    },
    campaignDescription() {
      if (this.campaign.commission_description) {
        return this.campaign.commission_description.replace(/<\/*\p>/g, '');
      }
      return '';
    },
  },
  methods: {
    ...mapActions(['fetchAdvertiser']),
    normalizeAdvertiserNameToCode(name) {
      return name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Z0-9]+/ig, '').toLowerCase();
    },
    isApprovedTo(code) {
      const codes = this.affiliateAdvertisers.map(ad => ({
        sourceName: this.normalizeAdvertiserNameToCode(ad.desCommissionEventSourceGroup),
        idtCommissionEventSourceGroup: ad.idtCommissionEventSourceGroup,
        indStatus: ad.indStatus,
      }));
      const advertiser = codes.find(x => x.sourceName === code);
      if (advertiser) {
        if (advertiser.indStatus === 'A') {
          this.moderate = 'aproved';
          this.isDisabled = true;
        }
        if (advertiser.indStatus === 'P') {
          this.textButton = 'Solicitação efetuada';
          this.isDisabled = true;
        }
        if (advertiser.indStatus === 'R') {
          this.textButton = 'Solicitação recusada';
          this.isDisabled = true;
        }
        if (advertiser.indStatus === 'I') {
          this.textButton = 'Quero Divulgar';
        }
      }
    },
    async requestModeration(idtProductSource) {
      try {
        await AdvertiserProgramApi.requestAdvertiserProgram(idtProductSource);
        this.textButton = 'Solicitação efetuada';
        this.isDisabled = true;
      } catch (error) {
        this.textButton = 'Tente novamente';
      }
    },
    async setCampaign(campaign) {
      await store.dispatch('setCampaign', campaign);
    },
  },
  watch: {
    affiliateAdvertisers: {
      immediate: true,
      handler(value) {
        if (value && value.length > 0) {
          this.isApprovedTo(this.campaign.code);
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
  .card-wrapper {
    padding: 0;

    .card {
      border: 0;
      border-radius: 8px;
      box-shadow: 0px 2px 3px rgba(black, .1);

      .cover {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        object-fit: cover;
        object-position: 50% 0;
        min-height: 180px;
      }

      .content {
        text-align: center;
        padding: 15px 24px;

        .title {
          text-align: left;
          font: 16px $font-1;
          font-weight: bold;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .description-item {
          text-align: left;
          display: flex;
          align-items: flex-start;
          line-height: 14px;
          margin: 10px 0;
          font: 14px $font-1;

          div {
            border-bottom: dashed 1px #B1B1B1;
            padding-bottom: 10px;
            flex: 8;

            p {
              margin: 0 !important;
            }

            span {
              font-weight: bold;
            }
          }

          img {
            margin-right: 13px;
            flex: 1;
          }

          &.last {
            margin-bottom: 20px;

            div {
              border: none;
            }
          }

          &.first {
            div {
              height: 40px;

              @media (max-width: 767px) {
                height: auto;
              }
            }
          }
        }

        a,.btn-moderation {
          display: inline-block;
          line-height: 40px;
          border-radius: 4px;
          outline: none;
          width: 80%;
          height: 40px;
          background: $strong-orange;
          color: white;
          box-shadow: 0px 2px 0px #E04E00;
          border: none;
          transition: background .1s ease-in;

          &:hover {
            text-decoration: none;
            background: lighten($strong-orange, 10%);
          }
        }

        .btn-moderation{
          padding: 0;
        }

      }
    }

    @media (max-width: 767px) {
      padding: 10px 0;
    }

    @media (min-width: 768px) {
      padding: 10px;
    }

    @media (min-width: 992px) {
      padding: 0 15px 15px 0;
    }
  }
</style>
